import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTableColumns, faUsers, faFileLines, faArrowRightFromBracket, faXRay, faXmark, faAdjust, faCab, faPersonCircleQuestion, faCircleUser, faCartFlatbed, faChartArea } from '@fortawesome/free-solid-svg-icons';
import { useAuth } from '../hooks/AuthContext';
import Tooltip from './ToolTip';
import { useEffect, useState } from 'react';
import { faAccessibleIcon, faAirbnb, faRProject } from '@fortawesome/free-brands-svg-icons';

function SideBar() {
    const { logout } = useAuth();
    const { oliLogout } = useAuth();
    const [role, setRole] = useState(localStorage.getItem('role')?.trim());
    useEffect(() => {
        const storedRole = localStorage.getItem('role')?.trim();
        setRole(storedRole);
    }, []);

    const ai_access = localStorage.getItem("ai_access")
    const platform = localStorage.getItem("isLoggedIn") === 'true' ? 'XR' : 'OLI';
    
    // Check if current page is Avironix related
    const isAvironixPage = window.location.pathname === "/Avironix" || 
                          window.location.pathname === "/avironixDashboard" || 
                          window.location.pathname.toLowerCase().includes("avironix");
    
    // Don't render sidebar at all for Avironix pages
    if (isAvironixPage) {
        return null;
    }
    
    return (
        <div className="bg-gray-800 h-full p-3 relative sbResponsive">
            <ul className="space-y-4">
                {!ai_access  &&
                    <li className='w-full h-full'>
                        <Tooltip tooltipText="Dashboard" placement="tooltip-right">
                            <a href="/dashboard?page=1" className={`flex items-center justify-center p-2 text-base font-normal hover:text-blue-500 rounded-lg text-white hover:bg-gray-700 ${window.location.href.includes("dashboard") ? "bg-gray-700" : "bg-gray-200"}`}>
                                <FontAwesomeIcon icon={faTableColumns} className={`text-xl ${window.location.href.includes("dashboard") ? "text-blue-500" : "text-blue-400"}`} />
                            </a>
                        </Tooltip>
                    </li>
                }
                {((role === '1' || role === '2' || role === '4' || role === '5') && !ai_access) &&
                    <li>
                        <Tooltip tooltipText="Account Management" placement="tooltip-right">
                            <a href="/roles?page=1" className={`flex items-center justify-center p-2 text-base font-normal hover:text-blue-500 rounded-lg text-white hover:bg-gray-700 ${window.location.href.includes("roles") ? "bg-gray-700" : "bg-gray-200"}`}>
                                <FontAwesomeIcon icon={faUsers} className={`text-xl ${window.location.href.includes("roles") ? "text-blue-500" : "text-blue-400"}`} />
                            </a>
                        </Tooltip>
                    </li>
                }
                {((role === '1' || role === '2' || role === '4' || role === '6' || role === '7'|| role === '8')  && !ai_access) &&
                    <li>
                        <Tooltip tooltipText="Configurator" placement="tooltip-right">
                            <a href="/configurator?page=1" className={`flex items-center justify-center p-2 text-base font-normal hover:text-blue-500 rounded-lg text-white hover:bg-gray-700 ${window.location.href.includes("configurator") ? "bg-gray-700" : "bg-gray-200"}`}>
                                <FontAwesomeIcon icon={faFileLines} className={`text-xl ${window.location.href.includes("configurator") ? "text-blue-500" : "text-blue-400"}`} />
                            </a>
                        </Tooltip>
                    </li>
                }
                {(role === '7'  && !ai_access) &&
                    <li>
                        <Tooltip tooltipText="3D Repo" placement="tooltip-right">
                            <a href="/3drepo" className={`flex items-center justify-center p-2 text-base font-normal hover:text-blue-500 rounded-lg text-white hover:bg-gray-700 ${window.location.href.includes("3drepo") ? "bg-gray-700" : "bg-gray-200"}`}>
                                <FontAwesomeIcon icon={faRProject} className={`text-xl ${window.location.href.includes("3drepo") ? "text-blue-500" : "text-blue-400"}`} />
                            </a>
                        </Tooltip>
                    </li>
                }
                {/* {(role === '1') &&
                    <li>
                        <Tooltip tooltipText="Convo AI" placement="tooltip-right">
                            <a href="/convoai" className={`flex items-center justify-center p-2 text-base font-normal hover:text-blue-500 rounded-lg text-white hover:bg-gray-700 ${window.location.href.includes("convoai") ? "bg-gray-700" : "bg-gray-200"}`}>
                                <FontAwesomeIcon icon={faAirbnb} className={`text-xl ${window.location.href.includes("convoai") ? "text-blue-500" : "text-blue-400"}`} />
                            </a>
                        </Tooltip>
                    </li>
                } */}
                {/* {(role === '1') &&
                    <li>
                        <Tooltip tooltipText="Custom GPT" placement="tooltip-right">
                            <a href="/CustomGPT" className={`flex items-center justify-center p-2 text-base font-normal hover:text-blue-500 rounded-lg text-white hover:bg-gray-700 ${window.location.href.includes("CustomGPT") ? "bg-gray-700" : "bg-gray-200"}`}>
                                <FontAwesomeIcon icon={faCartFlatbed} className={`text-xl ${window.location.href.includes("CustomGPT") ? "text-blue-500" : "text-blue-400"}`} />
                            </a>
                        </Tooltip>
                    </li>
                } */}

                {(window.location.pathname.replace(/^\/+/, '') === "AIChatBot") &&
                    <li>
                        <Tooltip tooltipText="AI BOT" placement="tooltip-right">
                            <a href="/AIChatBot" className={`flex items-center justify-center p-2 text-base font-normal hover:text-blue-500 rounded-lg text-white hover:bg-gray-700 ${window.location.href.includes("AIChatBot") ? "bg-gray-700" : "bg-gray-200"}`}>
                                <FontAwesomeIcon icon={faAirbnb} className={`text-xl ${window.location.href.includes("AIChatBot") ? "text-blue-500" : "text-blue-400"}`} />
                            </a>
                        </Tooltip>
                    </li>
                }

                {(window.location.pathname.replace(/^\/+/, '') === "TVSAIChatBot") &&
                    <li>
                        <Tooltip tooltipText="AI BOT" placement="tooltip-right">
                            <a href="/TVSAIChatBot" className={`flex items-center justify-center p-2 text-base font-normal hover:text-blue-500 rounded-lg text-white hover:bg-gray-700 ${window.location.href.includes("TVSAIChatBot") ? "bg-gray-700" : "bg-gray-200"}`}>
                                <FontAwesomeIcon icon={faAirbnb} className={`text-xl ${window.location.href.includes("TVSAIChatBot") ? "text-blue-500" : "text-blue-400"}`} />
                            </a>
                        </Tooltip>
                    </li>
                }

                {(window.location.pathname.replace(/^\/+/, '') === "TVSAIChatBot2") &&
                    <li>
                        <Tooltip tooltipText="AI BOT" placement="tooltip-right">
                            <a href="/TVSAIChatBot2" className={`flex items-center justify-center p-2 text-base font-normal hover:text-blue-500 rounded-lg text-white hover:bg-gray-700 ${window.location.href.includes("TVSAIChatBot2") ? "bg-gray-700" : "bg-gray-200"}`}>
                                <FontAwesomeIcon icon={faAirbnb} className={`text-xl ${window.location.href.includes("TVSAIChatBot2") ? "text-blue-500" : "text-blue-400"}`} />
                            </a>
                        </Tooltip>
                    </li>
                }  

                {(window.location.pathname.replace(/^\/+/, '') === "TVSAIChatBot3") &&
                    <li>
                        <Tooltip tooltipText="AI BOT" placement="tooltip-right">
                            <a href="/TVSAIChatBot3" className={`flex items-center justify-center p-2 text-base font-normal hover:text-blue-500 rounded-lg text-white hover:bg-gray-700 ${window.location.href.includes("TVSAIChatBot3") ? "bg-gray-700" : "bg-gray-200"}`}>
                                <FontAwesomeIcon icon={faAirbnb} className={`text-xl ${window.location.href.includes("TVSAIChatBot3") ? "text-blue-500" : "text-blue-400"}`} />
                            </a>
                        </Tooltip>
                    </li>
                } 

                {(window.location.pathname.replace(/^\/+/, '') === "TVSAIChatBot4") &&
                    <li>
                        <Tooltip tooltipText="AI BOT" placement="tooltip-right">
                            <a href="/TVSAIChatBot4" className={`flex items-center justify-center p-2 text-base font-normal hover:text-blue-500 rounded-lg text-white hover:bg-gray-700 ${window.location.href.includes("TVSAIChatBot4") ? "bg-gray-700" : "bg-gray-200"}`}>
                                <FontAwesomeIcon icon={faAirbnb} className={`text-xl ${window.location.href.includes("TVSAIChatBot4") ? "text-blue-500" : "text-blue-400"}`} />
                            </a>
                        </Tooltip>
                    </li>
                } 

                {window.location.pathname.replace(/^\/+/, '') === "traningAI" &&
                    <li>
                        <Tooltip tooltipText="AI BOT" placement="tooltip-right">
                            <a href="/traningAI" className={`flex items-center justify-center p-2 text-base font-normal hover:text-blue-500 rounded-lg text-white hover:bg-gray-700 ${window.location.href.includes("traningAI") ? "bg-gray-700" : "bg-gray-200"}`}>
                                <FontAwesomeIcon icon={faAirbnb} className={`text-xl ${window.location.href.includes("traningAI") ? "text-blue-500" : "text-blue-400"}`} />
                            </a>
                        </Tooltip>
                    </li>
                } 

                {window.location.pathname.replace(/^\/+/, '') === "PmmAI" &&
                    <li>
                        <Tooltip tooltipText="AI BOT" placement="tooltip-right">
                            <a href="/PmmAI" className={`flex items-center justify-center p-2 text-base font-normal hover:text-blue-500 rounded-lg text-white hover:bg-gray-700 ${window.location.href.includes("PmmAI") ? "bg-gray-700" : "bg-gray-200"}`}>
                                <FontAwesomeIcon icon={faAirbnb} className={`text-xl ${window.location.href.includes("PmmAI") ? "text-blue-500" : "text-blue-400"}`} />
                            </a>
                        </Tooltip>
                    </li>
                } 

                {(window.location.pathname.replace(/^\/+/, '') === "CallAI") &&
                    <li>
                        <Tooltip tooltipText="AI BOT" placement="tooltip-right">
                            <a href="/CallAI" className={`flex items-center justify-center p-2 text-base font-normal hover:text-blue-500 rounded-lg text-white hover:bg-gray-700 ${window.location.href.includes("CallAI") ? "bg-gray-700" : "bg-gray-200"}`}>
                                <FontAwesomeIcon icon={faAirbnb} className={`text-xl ${window.location.href.includes("CallAI") ? "text-blue-500" : "text-blue-400"}`} />
                            </a>
                        </Tooltip>
                    </li>
                } 

                {(window.location.pathname.replace(/^\/+/, '') === "V2CAI") &&
                    <li>
                        <Tooltip tooltipText="AI BOT" placement="tooltip-right">
                            <a href="/V2CAI" className={`flex items-center justify-center p-2 text-base font-normal hover:text-blue-500 rounded-lg text-white hover:bg-gray-700 ${window.location.href.includes("V2CAI") ? "bg-gray-700" : "bg-gray-200"}`}>
                                <FontAwesomeIcon icon={faAirbnb} className={`text-xl ${window.location.href.includes("V2CAI") ? "text-blue-500" : "text-blue-400"}`} />
                            </a>
                        </Tooltip>
                    </li>
                } 

                {(window.location.pathname.replace(/^\/+/, '') === "MauiXMaui") &&
                    <li>
                        <Tooltip tooltipText="AI BOT" placement="tooltip-right">
                            <a href="/MauiXMaui" className={`flex items-center justify-center p-2 text-base font-normal hover:text-blue-500 rounded-lg text-white hover:bg-gray-700 ${window.location.href.includes("MauiXMaui") ? "bg-gray-700" : "bg-gray-200"}`}>
                                <FontAwesomeIcon icon={faAirbnb} className={`text-xl ${window.location.href.includes("MauiXMaui") ? "text-blue-500" : "text-blue-400"}`} />
                            </a>
                        </Tooltip>
                    </li>
                } 

                {(window.location.pathname.replace(/^\/+/, '') === "SchneiderAI") &&
                    <li>
                        <Tooltip tooltipText="AI BOT" placement="tooltip-right">
                            <a href="/SchneiderAI" className={`flex items-center justify-center p-2 text-base font-normal hover:text-blue-500 rounded-lg text-white hover:bg-gray-700 ${window.location.href.includes("SchneiderAI") ? "bg-gray-700" : "bg-gray-200"}`}>
                                <FontAwesomeIcon icon={faAirbnb} className={`text-xl ${window.location.href.includes("SchneiderAI") ? "text-blue-500" : "text-blue-400"}`} />
                            </a>
                        </Tooltip>
                    </li>
                } 

                {(window.location.pathname.replace(/^\/+/, '') === "Drone") &&
                    <li>
                        <Tooltip tooltipText="AI BOT" placement="tooltip-right">
                            <a href="/Drone" className={`flex items-center justify-center p-2 text-base font-normal hover:text-blue-500 rounded-lg text-white hover:bg-gray-700 ${window.location.href.includes("Drone") ? "bg-gray-700" : "bg-gray-200"}`}>
                                <FontAwesomeIcon icon={faAirbnb} className={`text-xl ${window.location.href.includes("Drone") ? "text-blue-500" : "text-blue-400"}`} />
                            </a>
                        </Tooltip>
                    </li>
                } 

                {(window.location.pathname.replace(/^\/+/, '') === "MauiXMaui-laptop") &&
                    <li>
                        <Tooltip tooltipText="AI BOT" placement="tooltip-right">
                            <a href="/MauiXMaui-laptop" className={`flex items-center justify-center p-2 text-base font-normal hover:text-blue-500 rounded-lg text-white hover:bg-gray-700 ${window.location.href.includes("MauiXMaui-laptop") ? "bg-gray-700" : "bg-gray-200"}`}>
                                <FontAwesomeIcon icon={faAirbnb} className={`text-xl ${window.location.href.includes("MauiXMaui-laptop") ? "text-blue-500" : "text-blue-400"}`} />
                            </a>
                        </Tooltip>
                    </li>
                } 

                {(window.location.pathname.replace(/^\/+/, '') === "Maui4") &&
                    <li>
                        <Tooltip tooltipText="AI BOT" placement="tooltip-right">
                            <a href="/Maui4" className={`flex items-center justify-center p-2 text-base font-normal hover:text-blue-500 rounded-lg text-white hover:bg-gray-700 ${window.location.href.includes("Maui4") ? "bg-gray-700" : "bg-gray-200"}`}>
                                <FontAwesomeIcon icon={faAirbnb} className={`text-xl ${window.location.href.includes("Maui4") ? "text-blue-500" : "text-blue-400"}`} />
                            </a>
                        </Tooltip>
                    </li>
                } 
            </ul>
            
            <ul className='absolute bottom-0 left-0 space-y-2 px-3 py-4 w-full'>
                <Tooltip tooltipText="Logout" placement="tooltip-right">
                    <li onClick={() => {if(platform === "OLI"){oliLogout()} else {logout()}}} className="flex cursor-pointer items-center p-2 text-base font-normal rounded-lg hover:text-blue-500 text-white hover:bg-gray-700 bg-gray-200">
                        <FontAwesomeIcon icon={faArrowRightFromBracket} className={`text-xl rotate-180 text-blue-400`} />
                    </li>
                </Tooltip>
            </ul>
        </div>
    );
}

export default SideBar;